import React, { useContext, useState, useEffect, useRef } from 'react'
import { useStore, CustomViewType } from '../store'
import classNames from 'classnames'
import { TicketListManagerContext } from '~/service/TicketListManager'
import Filters from './views/Filters'
import { post } from '~/utils/api'
import { Menu, Dropdown } from 'antd'
import type { MenuProps } from 'antd'

type Props = {
  width: number
}

const Views: React.FC<Props> = ({ width }) => {
  const { filter, setFilter } = useContext(TicketListManagerContext)

  const {
    view,
    customView,
    setView,
    removeCustomView,
    setCustomView,
    setCheckedAll,
  } = useStore()

  const [filtersModal, setFiltersModal] = useState(false)

  const customViewRef = useRef(customView)
  customViewRef.current = customView

  const setTab = (name, e) => {
    e.preventDefault()
    setCheckedAll(false)
    setView(name)
    setFilter({
      ...filter,
      view: name,
      reportedBy: null,
      mailAccount: null,
      tags: null,
      title: null,
      category: null,
      subcategory: null,
      categoryStatus: null,
    })
  }

  const setCustomTab = data => {
    setView(data.name)
    setFilter({
      ...filter,
      view: data.status,
      reportedBy: data.reportedBy,
      mailAccount: data.mailAccount,
      tags: data.tags,
      title: data.title,
      category: data.category,
      subcategory: data.subcategory,
      categoryStatus: data.categoryStatus,
    })
  }

  const removeTab = async id => {
    const res = await post(`tickets/view/${id}/remove`)

    setView('open')
    setFilter({
      ...filter,
      view: 'open',
      reportedBy: null,
      mailAccount: null,
      tags: null,
      title: null,
      category: null,
      subcategory: null,
      categoryStatus: null,
    })
    removeCustomView(id)
  }

  const onClickView: MenuProps['onClick'] = ({ key }) => {
    const tab = customView.find(item => item.id == parseInt(key))
    setCustomTab(tab)
  }

  const menu = (
    <Menu
      onClick={onClickView}
      items={customViewRef.current
        .filter(item => item.hidden == true && item.name != view)
        .map(item => ({ label: item.name, key: item.id }))}
    />
  )

  useEffect(() => {
    if (width > window.innerWidth - 200) {
      let length =
        customViewRef.current.filter(item => item.hidden == false).length - 1

      setCustomView(
        customViewRef.current.map((item, index) =>
          length <= index ? { ...item, hidden: true } : item
        )
      )
    }
  }, [width])

  useEffect(() => {
    setCustomView(
      window.c.views.tickets.map((item: CustomViewType) => ({
        ...item,
        hidden: false,
      }))
    )
  }, [])

  return (
    <>
      <ul className="ticket-views">
        <li
          className={classNames('ticket-views-item', {
            active: view == 'open',
          })}
        >
          <a href="#" onClick={e => setTab('open', e)}>
            {intl.formatMessage({ id: 'tickets / view / open' })}
          </a>
        </li>
        <li
          className={classNames('ticket-views-item', {
            active: view == 'todo',
          })}
        >
          <a href="#" onClick={e => setTab('todo', e)}>
            {intl.formatMessage({ id: 'tickets / view / todo' })}
          </a>
        </li>
        <li
          className={classNames('ticket-views-item', {
            active: view == 'closed',
          })}
        >
          <a href="#" onClick={e => setTab('closed', e)}>
            {intl.formatMessage({ id: 'tickets / view / closed' })}
          </a>
        </li>
        {customViewRef.current.map(item => {
          if (!item.hidden || view == item.name) {
            return (
              <li
                key={item.id}
                className={classNames(
                  'ticket-views-item ticket-views-item--custom',
                  {
                    active: view == item.name,
                  }
                )}
              >
                {view == item.name ? (
                  <div>
                    {item.name}

                    <a
                      onClick={e => {
                        e.preventDefault()
                        removeTab(item.id)
                      }}
                      className="ticket-views-item-button"
                    >
                      <span className="fa fa-times" />
                    </a>
                  </div>
                ) : (
                  <a
                    className="is-custom"
                    href="#"
                    onClick={e => {
                      e.preventDefault()
                      setCustomTab(item)
                    }}
                  >
                    {item.name}
                  </a>
                )}
              </li>
            )
          }
        })}
        {customViewRef.current.find(item => item.hidden == true) && (
          <li className="ticket-views-item ticket-views-item--button">
            <Dropdown overlay={menu}>
              <a onClick={e => e.preventDefault()}>
                <i className="far fa-ellipsis-h"></i>
              </a>
            </Dropdown>
          </li>
        )}
        <li className="ticket-views-item ticket-views-item--button">
          <a onClick={() => setFiltersModal(!filtersModal)}>
            <i className="fas fa-plus"></i>
          </a>
        </li>
      </ul>
      <Filters
        setCustomTab={setCustomTab}
        filtersModal={filtersModal}
        setFiltersModal={setFiltersModal}
      />
    </>
  )
}

export default Views
